module.exports = __webpack_public_path__ + "static/media/rage_and_sorrow_album_art.3bc96ee3.png";